import { Injectable } from "@angular/core";
import { ServerRootService } from '@se/se.ui.html5';
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { catchError, Observable, throwError } from "rxjs";
import { VnaDicomRequest } from "../../models/vna-dicom-web/vna-dicom-request.classes";
@Injectable({
    providedIn: 'root',
})

export class VnaSetRequestClient extends ServerRootService {

    private readonly endPoint = '/Vna/SetRequest';
    private readonly url = this.getServerRoot() + this.endPoint;    

    constructor(private httpClient: HttpClient) {
        super();
    };

    setRequest(request: VnaDicomRequest): Observable<any> {
        return this.httpClient.post(
            this.url,
            request
        ).pipe(
            catchError(this.handleError)
        );
    }

    private handleError(error: HttpErrorResponse) {
        if (error.status === 0) {
            console.error('An error occurred:', error.error);
        } else {
            console.error(
                `Backend returned code ${error.status}, body was: `, error.error);
        }
        return throwError(() => new Error('Something bad happened; please try again later.'));
    }
}
